export default "__VITE_ASSET__DM_f3sj2__"